export const DATE_FORMATS = {
    s: 'YYYY-MM-DD HH:mm:ss',
    m: 'YYYY-MM-DD HH:mm',
    H: 'YYYY-MM-DD HH',
    D: 'YYYY-MM-DD',
    M: 'YYYY-MM',
    W: 'YYYY-wo',
    Q: 'YYYY-[Q]Q',
    Y: 'YYYY',
    HH: 'HH',
    Hm: 'HH:mm',
    Hms: 'HH:mm:ss',
};
export const NUMBER_COMPACT = [
    {
        compact: 'K',
        conversion: 1000,
    },
    {
        compact: 'M',
        conversion: 1000000,
    },
    {
        compact: 'B',
        conversion: 1000000000,
    },
    {
        compact: 'T',
        conversion: 1000000000000,
    },
];
